























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardOrder from "@/components/pemeriksaan/penunjang/CardOrder.vue";
import DataPenunjang from "@/services/DataPenunjang";
import { storePenunjang } from "@/store/modules/penunjang";
import { appModule } from "@/store/modules/app";
import { storeCopy } from "@/store/modules/copy";
import CardPenunjangLain from "@/components/pemeriksaan/penunjang/CardPenunjangLain.vue";
import CardPengantarKulturAntibiotika from "@/components/pemeriksaan/tabs/penunjang/CardPengantarKulturAntibiotika.vue";
import CardHasilPemeriksaanUsg from "@/components/pemeriksaan/tabs/penunjang/CardHasilPemeriksaanUsg.vue";
import CardHasilUsg from "@/components/pemeriksaan/tabs/penunjang/CardHasilUsg.vue";
import CardPermintaanPatologiAnatomi from "@/components/pemeriksaan/tabs/penunjang/CardPermintaanPatologiAnatomi.vue";
import CardRiwayatHasilLab from "@/components/pemeriksaan/tabs/penunjang/CardRiwayatHasilLab.vue";
import CardDokumentasiKelainanKulit from "@/components/pemeriksaan/assesmen/asesmenkulit/CardDokumentasiKelainanKulit.vue";
import TabOrderDarah from "@/components/pemeriksaan/order-darah/TabOrderDarah.vue";
import { ORDER_DARAH_SUB_TABS } from "@/components/pemeriksaan/order-darah/orderDarah.config";
import { userModule } from "@/store/modules/user";
import { scrollTabIntoView } from "@/utils/scrollTabIntoView";

@Component({
  components: {
    CardOrder,
    CardPenunjangLain,
    CardPengantarKulturAntibiotika,
    CardHasilPemeriksaanUsg,
    CardHasilUsg,
    CardPermintaanPatologiAnatomi,
    CardRiwayatHasilLab,
    CardDokumentasiKelainanKulit,
    TabOrderDarah
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardOrderPenunjang extends Vue {
  @Prop() sess_login!: object;
  @Prop() register!: string;
  @Prop() rm: string;
  @Prop({ default: false }) showHasilUsgRanap!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly showMonitoringShortcut!: boolean;
  @Prop({ default: null }) readonly deepLink!: any;

  isReadOnly!: () => boolean;

  get showDokumentasiKulit(): boolean {
    const u: any = userModule.user;
    return u && (u.unit_group_id == "09" || ["09", "2G"].includes(u.unit_id));
  }

  get lainnyaTabs() {
    return [
      {
        elemId: "lainnya-kultur-antibiotika",
        title: "Pengantar Kultur & Tes Kepekaan Antibiotika (Mikrobiologi)",
        icon: "mdi-bacteria",
        component: "CardPengantarKulturAntibiotika"
      },
      {
        elemId: "lainnya-hasil-usg",
        title: "Formulir Hasil Pemeriksaan USG",
        icon: "mdi-human-pregnant",
        component: this.showHasilUsgRanap
          ? "CardHasilUsg"
          : "CardHasilPemeriksaanUsg"
      },
      {
        elemId: "lainnya-patologi-anatomi",
        title: "Permintaan Pemeriksaan Patologi Anatomi",
        icon: "mdi-microscope",
        component: "CardPermintaanPatologiAnatomi"
      },
      ...(this.showDokumentasiKulit
        ? [
            {
              elemId: "lainnya-kelainan-kulit",
              title: "Dokumentasi Kelainan Kulit",
              icon: "mdi-image-multiple",
              component: "CardDokumentasiKelainanKulit"
            }
          ]
        : [])
    ];
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  tglIsi = new Date().toISOString().substr(0, 10);
  today = new Date().toISOString().substr(0, 10);
  tglShow = false;
  maxDate = new Date().toISOString().substr(0, 10);

  tab = "daftar-order";
  subTab = "lab-radiologi";
  lainnyaTab = "lainnya-kultur-antibiotika";
  subTabs = [
    { value: "lab-radiologi", title: "Lab dan Radiologi" },
    { value: "penunjang-lain", title: "Penunjang Lain" },
    { value: "order-darah", title: "Order Darah" },
    { value: "lainnya", title: "Lainnya" },
    { value: "riwayat-hasil-lab", title: "Riwayat Hasil Lab (Lintas Kunjungan)" }
  ];
  title = "";
  type = "";
  showModal = false;
  orderItemsLab = [];
  orderItemsRadiologi = [];
  alertOpen = false;
  err: object = {};
  detailOrderLab = {};
  detailOrderRo = {};
  detailPenunjangLain = {};

  created() {
    storePenunjang.act_all_order_lab_by_reg(this.register);
    storePenunjang.act_all_order_radiologi_by_reg(this.register);

    const param = {
      rm: this.rm,
      masuk: "",
      keluar: ""
    };
    storePenunjang.clear_list_lab();
    storePenunjang.clear_list_ro();
    storePenunjang.clear_hasil_ro();
    storePenunjang.act_list_ro_byRm(this.rm);

    storePenunjang.act_list_lab_byRm(param);
  }

  mounted() {
    const max = new Date(new Date().setDate(new Date().getDate() + 2));
    this.maxDate = max.toISOString().substring(0, 10);
    this.stateItemLab();
    this.stateItemRadiologi();
  }

  get statusPasteLab() {
    return storeCopy.copyLab;
  }

  get pasteLab() {
    return storeCopy.pastelab;
  }

  get statusPasteRo() {
    return storeCopy.copyRo;
  }

  get pasteRo() {
    return storeCopy.pastero;
  }

  stateItemLab() {
    storePenunjang.act_item_group_lab();
  }
  stateItemRadiologi() {
    storePenunjang.act_item_group_radiologi();
  }

  get stateorderlab() {
    return storePenunjang.listorderLab;
  }

  get stateorderradiologi() {
    return storePenunjang.listorderRadiologi;
  }
  get stateorderlabbyid() {
    return storePenunjang.orderLab;
  }
  get stateorderradiologibyid() {
    return storePenunjang.orderRadiologi;
  }

  getIdOrder(value) {
    if (value["type"] == "lab") {
      this.detailOrderLab = value["detail"];
    } else if (value["type"] == "ro") {
      this.detailOrderRo = value["detail"];
    } else {
      this.detailPenunjangLain = value["detail"];
    }
  }

  buatOrder() {
    this.tab = "buat-order";
  }
  setOrderItemsLab(items) {
    this.orderItemsLab = items;
  }
  resetOrderItemsLab() {
    this.orderItemsLab = [];
  }
  setOrderItemsRadiologi(items) {
    this.orderItemsRadiologi = items;
  }
  resetOrderItemsRadiologi() {
    this.orderItemsRadiologi = [];
  }
  alasanBatalLab(value) {
    const dt = DataPenunjang.cancelDataOrderLab(value["id"], value["alasan"]);
    dt.then(dt => {
      if (dt["data"]["status"] == 1) {
        storePenunjang.act_all_order_lab_by_reg(this.register);
        appModule.NoticeDelay("Berhasil Membatalkan Order Laboratorium");
      }
    });
  }

  alasanBatalRad(value) {
    const dt = DataPenunjang.cancelDataOrderRadiologi(
      value["id"],
      value["alasan"]
    );
    dt.then(dt => {
      if (dt["data"]["status"] == 1) {
        storePenunjang.act_all_order_radiologi_by_reg(this.register);
        appModule.NoticeDelay("Berhasil Membatalkan Order Radiologi");
      }
    });
  }

  showTab(value) {
    this.$emit("pageTab", value);
  }

  @Watch("lainnyaTab")
  onLainnyaTabChange() {
    this.$nextTick(() => scrollTabIntoView(this.$el));
  }

  @Watch("deepLink", { immediate: true })
  onDeepLink(payload: any) {
    if (!payload || payload.topTab !== "tab-penunjang") return;

    const elemId = payload.elemId;

    if (ORDER_DARAH_SUB_TABS.includes(elemId)) {
      this.subTab = "order-darah";
    } else if (this.lainnyaTabs.some(item => item.elemId === elemId)) {
      this.subTab = "lainnya";
      this.lainnyaTab = elemId;
    } else {
      this.subTab = this.subTabs.some(item => item.value === elemId)
        ? elemId
        : "lab-radiologi";
    }
  }
}
